"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBorder = getBorder;
exports.getBreakpoint = getBreakpoint;
exports.getColor = getColor;
exports.getPreset = getPreset;
exports.getRadius = getRadius;
exports.getShadow = getShadow;
exports.getShimmerOptions = getShimmerOptions;
exports.getSpacing = getSpacing;
var _lodash = require("lodash");
function getBorder(theme, border) {
  return (0, _lodash.get)(theme, "borders.".concat(border), border);
}
function getColor(theme, color) {
  return (0, _lodash.get)(theme, "colors.".concat(color), color);
}
function getPreset(theme, presetType, preset) {
  return (0, _lodash.get)(theme, "".concat(presetType, ".presets.").concat(preset), {});
}
function getRadius(theme, radius) {
  return (0, _lodash.get)(theme, "radii.".concat(radius), radius);
}
function getShadow(theme, value) {
  return (0, _lodash.get)(theme, "shadows.".concat(value), value);
}
function getSpacing(theme, value) {
  return (0, _lodash.get)(theme, "spacing.".concat(value), value);
}
function getBreakpoint(theme, breakpoint) {
  return (0, _lodash.get)(theme, "breakpoints.".concat(breakpoint), breakpoint);
}
function getShimmerOptions(theme, name) {
  return (0, _lodash.get)(theme, "shimmer.".concat(name), {});
}